import React from "react";
import { PageHeader, CardItem } from "../Components";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { baseUrl } from "env";
import SearchLoader from "./SearchLoader";
import axios from "axios";
class Comp extends React.PureComponent {
  constructor(props, context) {
    super(props, context);
    this.state = {
      posts: []
    };
  }
  fetchResult = async () => {
    let searchingQuery = this.props.location.search.split("?q=").join("");
    const res = await axios.get(`/api/search`, {
      params: {
        query: searchingQuery
      }
    });
    this.setState({
      ...res.data
    });
  };
  async componentDidMount() {
    await this.fetchResult();
  }
  async componentDidUpdate(prevProps) {
    if (this.props.location.search !== prevProps.location.search) {
      this.setState({
        loading: true
      });
      await this.fetchResult();
      setTimeout(() => {
        this.setState({
          loading: false
        });
      }, 1000);
    }
  }
  render = () => (
    <>
      <PageHeader headerClass="contact-us" pageName="Arama Sonuçu" />
      <div style={{ minHeight: "400px" }} className="container mt80 mb80">
        <div className="row">
          <SearchLoader loading={this.state.loading}>
            {this.state.posts && this.state.posts.length > 0 ? (
              this.state.posts.map((item, key) => (
                <CardItem
                  id={item.id}
                  thumbnail={`${baseUrl}/api/media/media/${item.cover_media_id}`}
                  key={key}
                  col={4}
                  title={item.title}
                />
              ))
            ) : (
              <p>Bir Sonuc Bulunamadi</p>
            )}
          </SearchLoader>
        </div>
      </div>
    </>
  );
}

export default Comp;
